import React, { useEffect, useState } from 'react';
import { message, Col, Row, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { getPortQualityReportInfo } from './api';
import Index from './component/quality/print';
import { createPDF } from '../../util/tool';
import './print.less';

const handling_opinion_type_config = ['', '龙头处理/Handled by Longtou', '运到SVC大仓/SVC大仓Transport to SVC warehouse', '其他/Others', '正常进行下阶段/Proceed to the next stage normally'];
export default function PortQualityReport() {
  const { id } = useParams();
  const [info, setInfo] = useState({});
  const [title, setTitle] = useState('');
  const [eTitle, setETitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [btn, setBtn] = useState(false);
  useEffect(() => {
    setLoading(false);
    async function portQualityReportInfo() {
      const { data: { code, msg, data } } = await getPortQualityReportInfo(({ id }));
      if (+code === 0) {
        setInfo(data);
        setTitle(`订单${data.order_no}-批次${data?.base?.bit_no}-柜号${data?.base?.container_no}关口质检记录`);
        setETitle(`Order${data.order_no}-Batch${data?.base?.bit_no}-Container${data?.base?.container_no}Clearance port inspection record`);
      } else {
        message.error(msg);
      }
      setLoading(true);
    }
    portQualityReportInfo();
    const timer = setTimeout(() => {
      setBtn(true);
      clearTimeout(timer);
    }, 3000);
  }, [id]);
  const showModal = (options = {}) => {
  };
  const createPdfMethod = async () => {
    await createPDF({ fileName: `${title}Clearance port inspection record.pdf`, url: window.location.href });
  };

  return (
    <div className='quality-report-container'>
      {btn ? <Button style={{ position: 'fixed', top: '48vh', right: 0, zIndex: 1 }} type='primary' onClick={createPdfMethod}>下载</Button> : null}
      <div className='quality-print-container' style={{ position: 'relative', paddingBottom: '60px', pageBreakBefore: 'awlays', pageBreakAfter: 'always' }}>
        {
          loading ? <>
            <div className='port-quality-report-base'>
              <div>
                <div className='title'>{title}</div>
                <div className='title'>{eTitle}</div>
                <div className='port-quality-report-title'>基本信息</div>
              </div>
              <Row className='port-quality-report-item'>
                <Col span={12}>批次号/Batch Number：{info?.base?.bit_no}</Col>
                <Col span={12}>柜号/Cabinet Number：{info?.base?.container_no}</Col>
                <Col span={12}>砍果时间//Harvest/Pick Date：{info?.extends?.pick_start_date}</Col>
                <Col span={12}>包装时间/Label Packing Date：{info?.extends?.label_pack_date}</Col>
                {+info.category !== 6 ? <Col span={12}>原柜是否查验/Original Cabinet Inspection：{info?.base?.original_cabinet_inspection}</Col> : null}
                <Col span={12}>质检时间/Quality Inspection Time：{info?.base?.quality_testing_time}</Col>
                <Col span={12}>质检流程类型/Quality Inspection Process：{+(info?.type) === 1 ? '倒柜质检/Change Container' : '原柜质检/No Container change'}</Col>
              </Row>
              {
                +info?.category !== 6 ?
                  <>
                    {info?.base?.car_list?.map((item, idx) => {
                      return <div key={idx}>
                        <Row className='port-quality-report-item'> <Col span={8}><span style={{ 'fontWeight': 'bold' }}>车辆{idx + 1}</span></Col></Row>
                        <Row className='port-quality-report-item'>
                          <Col span={24}>
                            <div>车头图片/司机图片/驾驶证</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.car_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                        </Row>
                        <Row className='port-quality-report-item'>
                          <Col span={12}>
                            <div>风口图片</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.tuyere_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div>预冷设置温度：{item?.precooling_temperature?.temperature} ℃</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.precooling_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                        </Row>
                        <Row className='port-quality-report-item'>
                          <Col span={12}>
                            <div>预冷出风温度：{item?.out_wind_temperature?.temperature} ℃</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.out_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div>预冷回风温度：{item?.in_wind_temperature?.temperature} ℃</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.in_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                        </Row>
                        <Row className='port-quality-report-item'>
                          <Col span={24}>
                            <div>排水口是否正常：{item?.drain?.is_normal}</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.drain?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div>IOT设备装车照片</div>
                            <div className='port-quality-report-item-imgs'>
                              {(item?.iot_equipment?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                            </div>
                          </Col>
                          {
                            +info?.category === 1 ? <Col span={12}>
                              <div>发车时间：{item.departure_time}</div>
                            </Col> : null
                          }
                        </Row>
                      </div>;
                    })
                    }
                  </>
                  : <>
                    <Row className='port-quality-report-item'>
                      <Col span={8}>
                        <div>出风温度：{info?.base?.out_wind_temperature?.temperature}℃</div>
                        <div className='port-quality-report-item-imgs'>
                          {(info?.base?.out_wind_temperature?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                        </div>
                      </Col>
                      <Col span={8}>
                        <div>回风温度：{info?.base?.in_wind_temperature?.temperature}℃</div>
                        <div className='port-quality-report-item-imgs'>
                          {(info?.base?.in_wind_temperature?.videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'video' })}><source src={item} /></video>)}
                          {(info?.base?.in_wind_temperature?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                        </div>
                      </Col>
                    </Row>
                  </>
              }
            </div>
            {
              +info?.category === 1 ? <>
                <div className='port-quality-report-base'>
                  <div className='port-quality-report-title'>开柜质检</div>
                  <Row className='port-quality-report-item'>
                    <Col span={8}><div>运输方式：{info?.open_quality?.transport_action_sheet}</div></Col>
                  </Row>
                  <Row className='port-quality-report-item'>
                    <Col span={8}>
                      <div>箱标签图片</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.box_label_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                  </Row>
                  <Row className='port-quality-report-item'>
                    <Col span={8}>
                      <div>原柜车头图片</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_truck_head_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>原柜果心温度：{info?.open_quality?.original_container_core?.temperature} ℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_core?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>原柜开柜味道：{info?.open_quality?.odor_upon_container_opening}</div>
                    </Col>
                    <Col span={8}>
                      <div>原柜风口图片</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_tuyere_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>原柜设置温度：{info?.open_quality?.original_container_precooling_temperature?.temperature} ℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_precooling_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>原柜出风温度：{info?.open_quality?.original_container_out_wind_temperature?.temperature} ℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_out_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>原柜回风温度：{info?.open_quality?.original_container_in_wind_temperature?.temperature} ℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.open_quality?.original_container_in_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                  </Row>
                </div>
              </> : null
            }
            <Index info={info?.container_last} category={info?.category} currentKey='container_last' showModal={showModal}></Index>
            {
              (+info?.type === 1) && <>
                <Index info={info?.container_middle} category={info?.category} currentKey='container_middle' showModal={showModal}></Index>
                <Index info={info?.container_head} category={info?.category} currentKey='container_head' showModal={showModal}></Index>
              </>
            }

            {
              info?.handling_opinion_type ? <div className='port-quality-report-base'>
                <div className='port-quality-report-title'>卖方处理意见</div>
                <div className='handling-opinion-item'>{handling_opinion_type_config[+info?.handling_opinion_type]}</div>
                <div className='handling-opinion-item'>{info?.handling_opinion_desc}</div>
              </div> : null
            }

          </> : null
        }
      </div>
    </div>
  );
}
